import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./styles/registration.scss";
import Swal from 'sweetalert2';
import { useAuth } from "../../pages/login/AuthProvider";
import { usePayment } from "../../components/PaymentContext";
import ContractCPA from "./ContractCPA";
import ContractCMA from "./ContractCMA";
import ContractEA from "./ContractEA";
import ContractUT from "./ContractUT";
import ContractRP from "./ContractRP";
import ContractCPE from "./ContractCPE";
import ContractSCU from "./ContractSCU";
import ContractCIA from "./ContractCIA";
import axios from "axios";
import { backend } from "../../components/apipath";


const contractMap = {
  "1": ContractCPA,
  "2": ContractCMA,
  "3": ContractEA,
  "4": ContractCPE,
  "5": ContractSCU,
  "6": ContractUT,
  "7": ContractRP,
  "8": ContractCIA,
};

function Registration() {
  const [isChecked, setIsChecked] = useState(false);
  const { authorized } = useAuth();
  const { step, setStep } = usePayment();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const authStr = localStorage.getItem("auth");
  const auth = authStr ? JSON.parse(authStr) : null;
  const mem_id = auth?.mem_id;
  const productId = queryParams.get("product_id") || localStorage.getItem("selectedPlan");

  let parentId = queryParams.get("parent_id") || localStorage.getItem("selectedParentId") || "1";
  parentId = String(parentId);

  const SelectedContract = contractMap[parentId] || null;

  useEffect(() => {
    localStorage.setItem("selectedParentId", parentId);
  }, [parentId]);

  useEffect(() => {
          if (step < 1) {
          navigate("/registration/plan");
          }
      }, [step, navigate]);

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  const handleNextButtonClick = async (e) => {
  e.preventDefault();

  if (!authorized) {
    Swal.fire({
      icon: "warning",
      color: "#224040",
      text: "尚未登入會員，請先登入。",
    }).then(() => {
      navigate(
        `/member/memberlogin?redirect=${encodeURIComponent(
          window.location.pathname + window.location.search
        )}`
      );
    });
    return;
  }

  if (!isChecked) {
    Swal.fire({
      icon: "warning",
      color: "#224040",
      text: "請先勾選已詳閱並且了解",
    });
    return;
  }

  if (!productId) {
    Swal.fire({
      icon: "error",
      color: "#224040",
      text: "缺少方案資訊，請先回上一頁選擇方案。",
    });
    navigate(`/registration/plan?parent_id=${parentId}`);
    return;
  }

  try {
    const res = await axios.post(
      `${backend}member/agree`,
      {
        mem_id: mem_id,
        parent_id: parentId,
        product_id: productId,
      },
      { withCredentials: true }
    );

    if (!res.data || !res.data.success) {
      throw new Error(res.data?.message || "合約同意紀錄失敗");
    }

    // Plan 完成是 step 1，合約同意完成設成 step 2
    setStep(2);
    navigate(
      `/registration/payinfo?product_id=${productId}&parent_id=${parentId}`
    );
  } catch (err) {
    console.error(err);
    Swal.fire({
      icon: "error",
      color: "#224040",
      text: "寫入合約同意紀錄時發生錯誤，請稍後再試。",
    });
  }
};


  return (
    <>
      {SelectedContract ? (
        <SelectedContract
          isChecked={isChecked}
          handleCheckboxChange={handleCheckboxChange}
          handleNextButtonClick={handleNextButtonClick}
        />
      ) : (
        <div className="text-center mt-5">無對應的合約內容</div>
      )}
    </>
  );
}

export default Registration;
